import React, {Component} from "react";
import Table from "../../../components/Table/Table";
import {request} from "../../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import MiniButton from "../../../components/MiniButton";
import SweetAlert from "react-bootstrap-sweetalert";
import {Input, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip} from "reactstrap";
import ReactLoading from "react-loading";
import NumberFormat from "react-number-format";
import Alert from "react-s-alert";

class DefterBeyanBilgileri extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            newCustomerForDbsModal: false,
            searchResultsTable: false,
            loading: false,
            searchResults: [],
            dataToSave: [],
            searchedCustomer: [],
        };
        this.fetchData = this.fetchData.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.addVknToCustomer = this.addVknToCustomer.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleSearh = this.handleSearh.bind(this);
        this.deleteSearch = this.deleteSearch.bind(this);
        this.onChange = this.onChange.bind(this);
        this.addVknForDbsToCustomer = this.addVknForDbsToCustomer.bind(this);
        this.onChangeDbsVkn = this.onChangeDbsVkn.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData(){
        let self = this;
        let params = {
            url: `/customer/fetchDbsVkn`,
            method: "post",
        }
        request(params)
            .then(function (response) {
                self.setState({data: response.data})
            }).catch(function (error) {
            showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
        });
    }

    deleteRow(row){
        let params = {
            url: `/customer/deleteDbsVkn`,
            method: "post",
            data: row.dbsVkn
        }
        request(params)
            .then(response =>{
                Alert.success(response.data,{
                    html: true,
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                })
                this.setState({alert: null});
                this.fetchData();
            }).catch(function (error) {
            showAxiosError(error);
            this.setState({alert: null})
        });
    }

    addVknToCustomer(){
        this.setState({
            newCustomerForDbsModal: true
        });
    }

    closeModal(){
        this.setState({
            newCustomerForDbsModal: false,
            searchVknTckn: null,
            searchResults: [],
            dataToSave: [],
            dataToShow: []
        });
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.handleSearh(this.state.searchVknTckn);
        }
    }

    handleSearh(key){
        let self = this;
        if (key || (/(.*[0-9]){3}/i.test(key))) {
            self.setState({loading: true});
            let params = {
                url: `/customer/fetchAssignedCustomersWithVknTckn/${key}`,
                method: "get"
            };
            return request(params)
                .then(response => {
                    let customers = response.data;
                    customers.map((cust,index) =>{
                        self.state.data.map(key => {
                            if (key.vknTckn === cust.vknTckn){
                                cust.dbsVkn = key.dbsVkn;
                            }
                        })
                    })
                    self.setState({searchResults:customers,searchResultsTable: true,loading: false});
                })
                .catch(function (error) {
                    showAxiosError(error);
                });
        }
    }

    onChange (e) {
        let value = e.target.value;
        this.setState({searchVknTckn: value});
    }

    onChangeDbsVkn(e,index, row){
        let dataToSave = deepCopyObject(this.state.dataToSave);
        let selectedCustomerVkn = deepCopyObject(this.state.searchResults);

        let newData = null;
        dataToSave.map((data,index) => {
            if(data.recordId !== null && data.recordId === row.recordId){
                newData = index;
            }
        });

        selectedCustomerVkn[index].dbsVkn = e.target.value;
        if (newData != null){
            dataToSave[newData] =  {recordId: selectedCustomerVkn[index].recordId, vkn:  e.target.value};
        }else {
            dataToSave.push({recordId: selectedCustomerVkn[index].recordId, vkn:  e.target.value});
        }
        this.setState({dataToSave: dataToSave,searchResults: selectedCustomerVkn});
    }

    deleteSearch(){
        this.setState({searchResultsTable: false});
    }

    addVknForDbsToCustomer(){
        let self = this;
        let data = deepCopyObject(self.state.dataToSave);
        data.map((dt,index) => {
            if(dt.vkn === ""){
                data.splice(index, 1);
            }
        });
        let params = {
            url: `/customer/saveVknForDbs`,
            method: "post",
            data: data
        }
        request(params)
            .then(response =>{
                Alert.success(response.data,{
                    html: true,
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                })
                this.closeModal();
                this.fetchData();
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    render() {
        const columns = [
            {
                Header: "VKN / TCKN",
                accessor: "vknTckn",
                sortable: false
            },
            {
                Header: "Adı",
                accessor: "customerName",
                sortable: false
            },
            {
                Header: "Soyadı",
                accessor: 'familyName',
                sortable: false
            },
            {
                Header: "DBS VKN",
                accessor: 'dbsVkn',
                sortable: false
            },
            {
                Header: "İşlemler",
                accessor: '',
                sortable: false,
                Cell: row => (
                    <div>
                        <MiniButton title="Sil"
                                    faIcon="fa-trash"
                                    color="danger"
                                    style={{margin: "0", background: '#fd7a7a'}}
                                    onClick={() => this.setState({
                                        alert: (
                                            <SweetAlert showCancel warning
                                                        disabled={this.state.deleteBtnDisabled}
                                                        confirmBtnText="Evet"
                                                        cancelBtnText="Hayır"
                                                        confirmBtnBsStyle="danger"
                                                        cancelBtnBsStyle="default"
                                                         title="Emin misiniz?"
                                                        onConfirm={() => {this.deleteRow(row)}}
                                                        onCancel={() => this.setState({alert: null})}
                                            >
                                                Müşteri tablodan silinecek.
                                            </SweetAlert>
                                        )
                                    })}/>
                    </div>
                )
            },
        ];

        let searchColumns = [
            {
                Header: "VKN/TCKN",
                accessor: "vknTckn",
                sortable: false
            },
            {
                Header: "Adı",
                accessor: "customerName",
                sortable: false
            },
            {
                Header: "Soyadı",
                accessor: "familyName",
                sortable: false
            },
            {
                Header: "DBS VKN",
                accessor: "",
                sortable: false,
                Cell: (row, index) => (
                    <div>
                        <Input
                            id="vkn"
                            type="text"
                            pattern="[0-9]*"
                            maxLength={10}
                            value={row.dbsVkn}
                            onChange={(e) => this.onChangeDbsVkn(e,index,row)}
                            className="form-control"/>

                    </div>
                )
            }
        ];

        return (
            <div>

                <div>{this.state.alert}</div>

                <div className="col-sm-12 " style={{marginBottom: '20px'}}>
                    <nav className="">
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
                                rel="tooltip" className="TekBtn ekle btn-icon"
                                disabled={this.props.fieldsDisabled}
                                onClick={() => {
                                    this.addVknToCustomer()
                                }}>Vkn ekle / DÜZENLE
                        </button>
                    </nav>
                </div>

                {!!this.state.data &&
                <div className="card-body">
                    <Table
                        columns={columns}
                        content={this.state.data}
                        total={this.state.data.length}
                        paginationEnabled={false}
                        fetchData={this.fetchData}
                    />
                </div>
                }

                <Modal isOpen={this.state.newCustomerForDbsModal} size='lg'>
                    <ModalHeader toggle={this.closeModal}>DBS Sistemi / VKN</ModalHeader>
                    <ModalBody>
                        <div className="card-header">
                            <div className="col-12 row">
                                <div className="col-sm-4">
                                    <label className="col-form-label">TCKN ile müşteri arayın: </label>
                                </div>
                                <div className="form-group col-sm-5">
                                    <input className="form-control"
                                           placeholder="En az 3 karekter giriniz. (VKN/TCKN)"
                                           id="searchVknTckn"
                                           name="searchVknTckn"
                                           onKeyPress={this.handleKeyPress}
                                           onChange={(e) => this.onChange(e)}
                                           value={this.state.searchVknTckn ? this.state.searchVknTckn : ""}
                                           type="text"/>
                                </div>
                                <div className="form-group col-sm-3">
                                    <MiniButton title="Ara" faIcon="fa fa-search"
                                                onClick={() => this.handleSearh(this.state.searchVknTckn)}
                                                color="success"/>
                                    <MiniButton title="Temizle" faIcon="fa fa-trash-alt"
                                                onClick={() => this.deleteSearch(this.state.searchVknTckn)}
                                                color="danger"/>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            {this.state.loading && <ReactLoading type="spinningBubbles" style={{width:"70px", height: "70px", margin: "10px auto 10px auto", fill: "#888"}}/>}
                            {!this.state.loading && this.state.searchResultsTable && this.state.searchResults.length !== 0 &&
                            <div>
                                <label style={{fontWeight: 'bold',fontSize: '17px'}}>Arama sonucu</label>
                                <Table
                                    columns={searchColumns}
                                    content={this.state.searchResults}
                                    total={this.state.searchResults.length}
                                    page={this.state.page}
                                    size={this.state.size}
                                    options={["5", "10", "20", "50", "100"]}
                                    paginationEnabled={false}
                                />
                            </div>
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <nav className="col-sm-12 row">
                            <div className="col-sm-2">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{background: 'rgb(158, 158, 158)', padding: '11px 45px 11px 20px'}}
                                        rel="tooltip" className="TekBtn vazgec"
                                        onClick={() => this.closeModal()}>İptal
                                </button>
                            </div>
                            <div className="col-sm-8"></div>
                            <div className="col-sm-2">
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding: '11px 45px 11px 20px'}}
                                        rel="tooltip" className="TekBtn kaydet"
                                        disabled={this.state.dataToSave.length === 0}
                                        onClick={() => this.addVknForDbsToCustomer()}>Onayla
                                </button>
                            </div>
                        </nav>
                    </ModalFooter>
                </Modal>

            </div>
        )
    }

}
export default DefterBeyanBilgileri;